module.exports = __webpack_public_path__ + "static/img/nuvem-palavras.62ffd47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nuvem-palavras.png
// module id = bjKa
// module chunks = 1